import { TIER_DISPLAY_NAME, normalizeTier } from '@/types';

const COLORS: Record<string, string> = {
  free: 'bg-slate-100 text-slate-700',
  craft: 'bg-sky-100 text-sky-800',
  workshop: 'bg-indigo-100 text-indigo-800',
  atelier: 'bg-violet-100 text-violet-800',
  business: 'bg-amber-100 text-amber-900',
  business_plus: 'bg-amber-200 text-amber-950',
};

export function TierBadge({ tier, trialing }: { tier: string; trialing?: boolean }) {
  const t = normalizeTier(tier);
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${COLORS[t]}`}>
      {TIER_DISPLAY_NAME[t]}
      {trialing ? ' · trial' : ''}
    </span>
  );
}
